import { useEffect } from "react";

export const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Este efecto se ejecutará solo una vez, cuando el componente se monte

  return null;
};
